import {areIntervalsOverlapping, endOfDay, parse} from 'date-fns';
import {BookedStatus, Workspace, WorkspaceBookType} from '@innowise-group/core';

const COWORKING_STATUSES: WorkspaceBookType[] = ['Coworking Free', 'Coworking Booked'];

export type BookingModeFilterRange = {
  start: Date;
  end: Date;
};

const toBookingInterval = (status: BookedStatus) => {
  const start = status.range.startDay ? parse(status.range.startDay, 'dd.MM.yyyy', new Date()) : null;
  const end = status.range.endDay ? endOfDay(parse(status.range.endDay, 'dd.MM.yyyy', new Date())) : null;

  if (!start || !end) {
    return null;
  }

  return {start, end};
};

export const isWorkspaceBookedInRange = (
  workspace: Workspace,
  filterRange?: BookingModeFilterRange | null,
): boolean => {
  if (workspace.isBooked) {
    return true;
  }

  if (!filterRange?.start || !filterRange?.end || !workspace.bookedStatus?.length) {
    return false;
  }

  return workspace.bookedStatus.some((status) => {
    const interval = toBookingInterval(status);
    if (!interval) {
      return false;
    }

    return areIntervalsOverlapping(
      {start: interval.start, end: interval.end},
      {start: filterRange.start, end: filterRange.end},
    );
  });
};

/** Apply booking-mode Free/Booked paint from API `isBooked` (blue) with bookedStatus fallback. */
export const mapWorkspacesForBookingMode = (
  workspaces: Workspace[],
  filterRange?: BookingModeFilterRange | null,
): Workspace[] =>
  workspaces.map((workspace) => {
    if (isWorkspaceBookedInRange(workspace, filterRange)) {
      const bookedStatus: WorkspaceBookType = workspace.status === 'Coworking Booked' ? 'Coworking Booked' : 'Booked';
      return {...workspace, status: bookedStatus};
    }

    if (COWORKING_STATUSES.includes(workspace.status as WorkspaceBookType)) {
      return {...workspace, status: 'Coworking Free' as WorkspaceBookType};
    }

    return {...workspace, status: 'Free' as WorkspaceBookType};
  }) as Workspace[];
